import i18n from "@/i18n";
import { getDataTimeDecay } from "@services/alert/time-decay";
import common from "@assets/js/common";
import dayjs from "dayjs";

const state = {
    autoRefreshTimeOffset: 1,
    loading: false,
    alertData: [],
    alertHeader: [
        { text: i18n.t("common.table.login"), value: "login", align: "left" },
        { text: i18n.t("common.table.name"), value: "name", align: "left" },
        { text: "Book", value: "book", align: "left" },
        {
            text: i18n.t("common.table.dailyPnl"),
            value: "daily_pnl",
            align: "right",
        },
        {
            text: i18n.t("common.table.triggerTime"),
            value: "trigger_time",
            align: "left",
            width: 170,
        },
        {
            text: i18n.t("common.table.chart"),
            value: "full_time_decay_data",
            align: "left",
            sortable: false,
        },
    ],
    alertDataAmount: 0,
    csvHeader: {
        Login: "login",
        Symbol: "symbol",
        Book: "book",
        "Total Volume": "total_volume",
        Order: "order",
        "Trigger Time": "trigger_time",
    },
    selectedDate: null,
};

const actions = {
    getDataTimeDecayAction({ commit }, data) {
        commit("UPDATE_LOADING", true);
        getDataTimeDecay(data).then((res) => {
            res.data.data.forEach((item) => {
                item.book = item.book.replaceAll(";", ", ");
            });
            commit("UPDATE_ALERT_DATA", res.data.data);
            commit("UPDATE_AMOUNT", res.data.count);
            commit("UPDATE_LOADING", false);
        });
    },
};

const mutations = {
    UPDATE_ALERT_DATA(state, data) {
        state.alertData = data;
    },
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_ALERT_HEADER(state, data) {
        state.alertHeader = data;
    },
    UPDATE_SELECTED_DATE(state, data) {
        state.selectedDate = dayjs(data).unix();
    },
    UPDATE_AMOUNT(state, data) {
        state.alertDataAmount = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
